const ko = {
  /* ── Navbar ─────────────────────────────── */
  nav_about: '회사소개',
  nav_products: '제품소개',
  nav_features: '기술력',
  nav_contact: '문의하기',
  nav_cta: '견적 문의',
  nav_menu_open: '메뉴 열기',

  /* ── Hero ──────────────────────────────── */
  hero_badge: 'PIPE · TUBE\u00a0·\u00a0FITTING · FLANGE · PILE · PE COATING',
  hero_title_line1: '강관 산업의',
  hero_title_highlight: '신뢰할 수 있는',
  hero_title_line3: '파트너',
  hero_subtitle: '신뢰를 최우선 가치로 삼는 시너지스틸은 파이프, 튜브, 피팅, 강관파일 등 다양한 제품을 업계 최저가 수준의 경쟁력 있는 가격과 확실한 품질로 공급하여 고객 만족을 실현하겠습니다.\n견적 문의 주시면 신속하고 친절하게 대응해 드리겠습니다.',
  hero_stat1_label: '년 경력',
  hero_stat2_label: '납품 현장',
  hero_cta_quote: '무료 견적 문의',
  hero_cta_products: '제품 보기',
  hero_scroll: 'SCROLL',

  /* ── About ─────────────────────────────── */
  about_section_label: '/ ABOUT SYNERGY STEEL',
  about_title_line1: '강관 산업의 시작과 끝,',
  about_title_highlight: '시너지스틸',
  about_title_line2: '이 함께합니다',
  about_para1: '15년 이상의 현장 경험을 바탕으로, 고객 맞춤형 자재 솔루션과 신속한 납기를 약속드립니다. 시너지스틸은 전국 현장에 안정적인 공급망을 운영하고 있으며, 2022년 무역의 날 \'백만불 수출의 탑\'을 수상하며 글로벌 시장에서의 경쟁력과 성과를 인정받았습니다.',
  about_para2: '또한, 엄격한 품질관리 기준을 적용하여 국제 규격(ASTM, API, ASME 등)에 부합하는 제품만을 공급하며, 프로젝트 특성에 맞는 최적의 사양을 제안합니다. 풍부한 공급 경험을 기반으로 EPC, 시공사, 유통사 등 다양한 고객과 협력해 왔으며, 긴급 자재 대응 및 소량 주문에도 유연하게 대응하고 있습니다.',
  about_para3: '시너지스틸은 단순한 자재 공급을 넘어 프로젝트의 성공적인 수행을 지원하는 파트너로서, 경쟁력 있는 가격과 신뢰할 수 있는 품질, 책임감 있는 서비스를 제공합니다. 앞으로도 지속적인 공급망 확대와 품질 향상을 통해 고객 만족을 최우선으로 하겠습니다.',
  about_cert0_label: 'KS 인증',
  about_cert0_sub: '한국 산업규격',
  about_cert1_label: 'ISO 9001',
  about_cert1_sub: '품질경영시스템',
  about_cert2_label: '조달청 등록',
  about_cert2_sub: '공공구매 인증',
  about_img_alt: '노동민 대표이사',

  /* ── Products ──────────────────────────── */
  products_section_label: '/ PRODUCTS',
  products_title: '주요 제품 라인업',
  products_subtitle: '모든 제품은 KS 및 국제 규격을 준수하며 품질 보증서가 제공됩니다.',
  products_spec_btn: '규격 상세표 보기',
  products_quote_btn: '견적 문의하기',
  /* main products */
  prod_pipe_name: '파이프 (Pipe)',
  prod_fitting_name: '피팅 (Fitting)',
  prod_fitting_desc: '엘보, 티, 리듀서, 캡 등 다양한 파이프 피팅 제품을 공급합니다. 높은 내압 성능과 정밀한 치수로 산업 현장의 안전을 책임집니다.',
  prod_fitting_tag0: '엘보',
  prod_fitting_tag1: '티',
  prod_fitting_tag2: '리듀서',
  prod_fitting_tag3: '캡',
  prod_flange_name: '플랜지 (Flange)',
  prod_flange_desc: 'WN, SO, BL, SW, LJ, TH 등 모든 타입의 플랜지를 KS, ANSI/ASME 규격으로 공급합니다. 고압 및 고온 환경에서도 안정적인 밀봉 성능을 보장합니다.',
  prod_flange_tag0: 'WN형',
  prod_flange_tag1: 'SO형',
  prod_flange_tag2: 'BL형',
  prod_flange_tag3: 'SW형',
  prod_pile_name: '강관말뚝 (Pile)',
  prod_pile_desc: '건물 기초 및 대형 토목 구조물의 지반 보강에 사용되는 대구경 강관 파일입니다. 높은 지지력과 우수한 수직·수평 하중 저항성으로 고층 빌딩, 교량, 항만 공사 현장에 최적의 기초 솔루션을 제공합니다.',
  prod_pile_tag0: '강관파일',
  prod_pile_tag1: '대구경',
  prod_pile_tag2: '기초공사',
  prod_pile_tag3: 'KS F 4602',
  prod_pe_coating_name: 'PE 코팅 (PE Coating)',
  prod_pe_coating_desc: '파이프 외면에 폴리에틸렌(PE) 코팅을 적용하여 부식을 방지합니다. 매립형 배관이나 해저 배관 등 가혹한 환경에서도 장기 내구성을 보장합니다.',
  prod_pe_coating_tag0: '3LPE',
  prod_pe_coating_tag1: '부식방지',
  prod_pe_coating_tag2: '매립배관',
  /* pipe subtypes */
  pipe_seamless_name: '심레스 파이프',
  pipe_seamless_desc: '이음매 없이 제조된 고품질 무계목 강관입니다. 용접부가 없어 균일한 강도와 뛰어난 내압 성능을 자랑하며, 고온·고압이 요구되는 발전소, 석유화학 플랜트, 보일러 배관 등에 최적화된 제품입니다.',
  pipe_seamless_tag0: '무계목관',
  pipe_seamless_tag1: '고압배관',
  pipe_seamless_tag2: '보일러용',
  pipe_seamless_tag3: 'ASTM A106',
  pipe_pressure_name: '압력배관',
  pipe_pressure_desc: '고압 유체 및 증기 수송에 특화된 압력배관용 강관입니다. KS D3562 및 ASME/ANSI 규격을 준수하며 두꺼운 관 두께와 엄격한 비파괴검사를 통해 플랜트 설비의 안전성을 보장합니다.',
  pipe_pressure_tag0: '압력배관용',
  pipe_pressure_tag1: 'KS D3562',
  pipe_pressure_tag2: 'SCH 40~160',
  pipe_pressure_tag3: '비파괴검사',
  pipe_general_name: '일반배관',
  pipe_general_desc: '상·하수도, 건물 배관, 공조 설비 등 일반 유체 수송에 사용되는 범용 배관용 강관입니다. 경제성과 시공 편의성이 뛰어나며 KS D3507 / KS D3595 규격으로 안정적인 품질을 제공합니다.',
  pipe_general_tag0: '배관용',
  pipe_general_tag1: 'KS D3507',
  pipe_general_tag2: '범용',
  pipe_general_tag3: '상하수도',
  pipe_structural_name: '구조용 파이프',
  pipe_structural_desc: '건축 구조물, 교량, 철골 구조 등 하중을 받는 구조 부재로 사용되는 강관입니다. 원형·각형·직사각형 등 다양한 단면 형태로 제공되며 뛰어난 좌굴 저항성과 높은 단면 효율을 자랑합니다.',
  pipe_structural_tag0: '원형강관',
  pipe_structural_tag1: '각형강관',
  pipe_structural_tag2: '건축구조용',
  pipe_structural_tag3: 'KS D3566',
  pipe_stainless_name: '스테인레스관',
  pipe_stainless_desc: '식품, 제약, 화학 플랜트 등 위생 및 내식성이 중요한 환경에 사용되는 스테인리스 파이프입니다. SUS304 / SUS316L 등 다양한 재질 옵션과 BA·EP 표면 마감으로 고부가가치 배관 솔루션을 제공합니다.',
  pipe_stainless_tag0: 'SUS304',
  pipe_stainless_tag1: 'SUS316L',
  pipe_stainless_tag2: '식품용',
  pipe_stainless_tag3: '위생배관',
  pipe_alloy_name: '합금강관',
  pipe_alloy_desc: '고온·고압 환경의 발전소, 석유화학 플랜트에 사용되는 크롬-몰리브덴 합금강 파이프입니다. 탁월한 내열성과 장시간 크리프 강도로 초임계 발전소 및 정유 플랜트의 핵심 배관 소재로 사용됩니다.',
  pipe_alloy_tag0: 'P11',
  pipe_alloy_tag1: 'P22',
  pipe_alloy_tag2: 'P91',
  pipe_alloy_tag3: '고온고압용',

  /* ── Features ──────────────────────────── */
  features_section_label: '/ WHY SYNERGY STEEL',
  features_title: '시너지스틸을 선택해야 하는 이유',
  features_subtitle: '고객의 현장을 최우선으로 생각하는 강관 전문 기업',
  feat0_title: '엄격한 품질 관리',
  feat0_desc: 'KS, ASTM, JIS 등 국내외 규격을 철저히 준수하며 모든 제품에 대해 품질 검사 성적서를 발행합니다. 고객의 현장 안전을 최우선으로 생각합니다.',
  feat0_highlight: 'KS/ASTM/JIS 준수',
  feat1_title: '신속한 납기 보증',
  feat1_desc: '체계적인 재고 관리 시스템을 통해 긴급 주문에도 신속하게 대응합니다. 전국 네트워크를 활용하여 현장 요구 일정에 맞춘 납품을 실현합니다.',
  feat1_highlight: '24시간 내 출고 가능',
  feat2_title: '전문가 기술 지원',
  feat2_desc: '15년 이상 경력의 강관 전문가가 제품 선정부터 시공까지 원스톱 기술 지원을 제공합니다. 복잡한 프로젝트도 최적의 솔루션으로 해결합니다.',
  feat2_highlight: '15년+ 전문 경력',
  feat3_title: '합리적인 가격 정책',
  feat3_desc: '직수입 및 국내 제조사와의 긴밀한 파트너십을 통해 중간 유통 마진을 최소화하고, 고객에게 최고의 가성비를 제공합니다.',
  feat3_highlight: '직수입 가격 경쟁력',
  feat4_title: '글로벌 공급 네트워크',
  feat4_desc: '한국, 일본, 중국, 유럽의 주요 제조사와 직거래 체계를 구축하여 모든 규격과 재질의 제품을 안정적으로 조달할 수 있습니다.',
  feat4_highlight: '글로벌 4개국 네트워크',
  feat5_title: '책임감 있는 애프터서비스',
  feat5_desc: '납품 후에도 지속적인 기술 지원과 신속한 교체 서비스를 통해 고객과 장기적인 파트너 관계를 이어갑니다.',
  feat5_highlight: '납품 후 책임 AS',
  features_banner_title: '지금 바로 견적을 받아보세요',
  features_banner_subtitle: '24시간 이내 전문 상담사가 맞춤 견적을 제공해드립니다',
  features_banner_phone_cta: '전화 문의',

  /* ── Contact ───────────────────────────── */
  contact_section_label: '/ CONTACT US',
  contact_title_line1: '언제든지',
  contact_title_line2: '문의해주세요',
  contact_subtitle: '파이프, 피팅, 플랜지, 파일, PE코팅 제품에 대한 견적 및 기술 문의를 받고 있습니다. 전문 상담사가 24시간 이내에 답변드립니다.',
  contact_info_mobile: '모바일',
  contact_info_phone: '대표 전화',
  contact_info_fax: '팩스',
  contact_info_email: '이메일',
  contact_info_address: '주소',
  contact_map_title: '시너지스틸 위치',
  contact_form_title: '견적 / 제품 문의',
  form_name_label: '담당자명',
  form_name_placeholder: '홍길동',
  form_company_label: '회사명',
  form_company_placeholder: '(주)회사명',
  form_email_label: '이메일',
  form_phone_label: '연락처',
  form_phone_placeholder: '010-0000-0000',
  form_product_label: '문의 제품',
  form_product_placeholder: '제품을 선택해주세요',
  form_product_pipe: '파이프 (Pipe)',
  form_product_fitting: '피팅 (Fitting)',
  form_product_flange: '플랜지 (Flange)',
  form_product_pile: '파일 (Pile)',
  form_product_pe: 'PE 코팅 (PE Coating)',
  form_product_other: '기타 / 복합 문의',
  form_message_label: '문의 내용',
  form_message_placeholder: '규격, 수량, 납기 일정 등 필요한 내용을 상세히 기재해주세요.',
  form_message_limit: '500자를 초과할 수 없습니다.',
  form_submit: '문의 보내기',
  form_sending: '전송 중...',
  form_notice: '24시간 이내 담당자가 회신드립니다 · 영업일 기준',
  form_error: '전송에 실패했습니다. 잠시 후 다시 시도하시거나 02-6941-1750 으로 연락해주세요.',
  form_success_title: '문의가 접수되었습니다!',
  form_success_desc: '24시간 이내에 담당자가 연락드리겠습니다.',
  form_success_again: '다시 문의하기',
  form_required: '*',

  /* ── Footer ────────────────────────────── */
  footer_brand_desc: '파이프 · 피팅 · 플랜지 · 파일 · PE코팅 전문 공급 기업. 대한민국 산업 인프라의 신뢰할 수 있는 강관 파트너입니다.',
  footer_nav_title: '바로가기',
  footer_products_title: '제품 라인업',
  footer_copyright: '© 2025 시너지스틸 (Synergy Steel). All rights reserved. 대표이사: 노동민',

  /* ── SpecModal ─────────────────────────── */
  spec_modal_subtitle: 'SPECIFICATION TABLE',
  spec_modal_title_suffix: '— 규격 상세표',
  spec_notes_label: '유의사항 / NOTES',
  spec_footer_note: '규격 외 치수·재질은 맞춤 제작 가능합니다. 별도 문의 바랍니다.',
  spec_custom_btn: '규격 맞춤 문의',
  spec_close_btn: '닫기',
  /* notes per product */
  spec_note_seamless_0: '심레스(무계목)관은 용접부가 없어 고온·고압 환경에서 균일한 내압 성능을 발휘합니다.',
  spec_note_seamless_1: 'SCH 160 및 XXH(Double Extra Heavy) 두께도 공급 가능합니다.',
  spec_note_seamless_2: '화학성분 분석서(MTR) 및 비파괴검사(UT) 성적서 제공 가능합니다.',
  spec_note_pressure_0: '압력배관용 강관은 수압시험(Hydrostatic Test) 후 출고됩니다.',
  spec_note_pressure_1: 'KS D3562 SPPS 380 / 420 두 가지 강도 등급 모두 공급 가능합니다.',
  spec_note_pressure_2: '비파괴검사(UT, RT) 및 화학성분 분석서(MTR) 제공 가능합니다.',
  spec_note_general_0: 'KS D3507: 배관용 탄소강 강관 / KS D3595: 일반 구조용 탄소강 강관',
  spec_note_general_1: '외면 방청 도장(광명단 또는 에나멜) 처리 후 출고됩니다.',
  spec_note_general_2: 'DN 250 이상 대구경 및 특수 두께는 사전 협의가 필요합니다.',
  spec_note_structural_0: '두께 옵션이 여럿인 경우 최소~최대 중량을 범위로 표기했습니다.',
  spec_note_structural_1: '특수 단면(타원형, 이형관 등)은 별도 문의해주세요.',
  spec_note_structural_2: '건축구조용 강관의 항복강도: 355MPa 이상 (KS D3566 SHK400W)',
  spec_note_stainless_0: '재질: SUS304 (기본) / SUS304L / SUS316 / SUS316L (요청 시 공급)',
  spec_note_stainless_1: '표면 마감: AP (에니얼링·피클링), EP (전해연마) 선택 가능',
  spec_note_stainless_2: '식품·의약품 배관 사용 시 BA 마감 또는 EP 마감을 권장합니다.',
  spec_note_alloy_0: 'P91 (9Cr-1Mo-V): 장시간 크리프 강도가 우수하여 초고온·고압 플랜트에 사용됩니다.',
  spec_note_alloy_1: '모든 합금강관은 열처리(노말라이징+템퍼링) 후 출고됩니다.',
  spec_note_alloy_2: '화학성분 분석서(MTR) 및 비파괴검사(UT/RT) 성적서 제공 가능합니다.',
  spec_note_fitting_0: 'BW: 맞대기 용접 / SW: 소켓 용접 / THD: 나사식',
  spec_note_fitting_1: 'CS(탄소강): A234 WPB / SS(스테인리스): A403 WP304/316',
  spec_note_fitting_2: '두께, 재질, 압력등급 맞춤 제작 및 RTJ·RF 면가공 가능',
  spec_note_flange_0: 'WN: 용접형(Weld Neck) / SO: 슬립온(Slip On) / BL: 블라인드(Blind)',
  spec_note_flange_1: '재질: A105(탄소강) / A182 F304/316(스테인리스) / A182 F11/F22(합금강)',
  spec_note_flange_2: '압력등급 600# ~ 2500# 및 RTJ 그루브 가공 제품도 공급 가능',
  spec_note_pile_0: '이음 방법: 현장 용접 이음 또는 기계식 이음 선택 가능합니다.',
  spec_note_pile_1: '도장 처리: 외면 방청 도장 기본 / 해상 환경 시 에폭시 도장을 추천합니다.',
  spec_note_pile_2: 'φ1000 이상 대구경 파일은 제작 기간 및 운반 조건 사전 협의가 필요합니다.',
  'spec_note_pe-coating_0': '3LPP(폴리프로필렌) 코팅은 고온 배관 및 해저 배관에 권장됩니다.',
  'spec_note_pe-coating_1': 'FBE(Fusion Bonded Epoxy) 코팅은 내부 코팅에도 적용 가능합니다.',
  'spec_note_pe-coating_2': '코팅 홀리데이(핀홀) 검사 및 접착력 시험 성적서 제공 가능합니다.',
};

export default ko;
